// @ts-nocheck
import { createAction } from '@reduxjs/toolkit';

export const fetchStoreColumns = createAction('orderByStore/fetch-columns', function prepare({ tableId }) {
	return { payload: { tableId } };
});

export const fetchStoreOrderData = createAction(
	'orderByStore/fetch-order-data',
	function prepare({ tableId, orderStatusValue, refreshKey }) {
		return { payload: { tableId, orderStatusValue, refreshKey } };
	}
);
